<template>
    <div><UploadsListInnerTable :item="{ record_id: $route.params.id, isas_error: item ? item.isas_error : null }" /></div>
</template>

<script>
import UploadsListInnerTable from '../uploadsList/UploadsTableInnerTable';
export default {
    props: ['item'],
    components: { UploadsListInnerTable }
};
</script>

<style></style>
